module.exports = __webpack_public_path__ + "static/media/service_visual.88939baf.mp4";